var stepsData = {
  name: 'steps',
  data: [{// 待添加需要修改的变量
  }]
};
export var stepsGroupData = {
  name: 'stepsGroup',
  data: [{// 待添加需要修改的变量
  }]
};
export default stepsData;